<template>
    <!-- 对话框 -->
    <el-drawer title="配置信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <el-form ref="form" :model="submit_data" label-width="80px" style="overflow-y: auto; height: 85vh">
                <el-form-item label="分享主体:" label-width="120px">
                    <el-button v-model="submit_data.type" type="primary">乘客</el-button>
                </el-form-item>
                <el-form-item label="奖励金额:" label-width="120px">
                    <el-input
                            v-model="submit_data.share_money"
                            :placeholder="submit_rules.share_money.placeholder"
                            style="width: 50%"
                    ></el-input>
                </el-form-item>

                <el-form-item label="司机承担金额:" label-width="120px">
                    <el-input v-model="submit_data.driver_bear" :placeholder="submit_rules.driver_bear.placeholder"
                              style="width: 50%">
                    </el-input>
                </el-form-item>

                <el-form-item label="扫码用户:" label-width="120px">
                    <!-- <el-switch v-model="face_btn" active-text="新用户" inactive-text="所有用户" @change="faceChange"> </el-switch> -->

                    <el-switch
                            v-model="submit_data.face_new"
                            active-text="新用户"
                            inactive-text="所有用户"
                            active-value="1"
                            inactive-value="0"
                    >
                    </el-switch>
                </el-form-item>
                <el-form-item label="选择使用状态:" label-width="120px">
                    <!-- <el-switch v-model="status_btn" active-text="启用" inactive-text="禁用" @change="statusChange"></el-switch> -->
                    <el-switch
                            v-model="submit_data.status"
                            active-text="启用"
                            inactive-text="禁用"
                            active-value="1"
                            inactive-value="0"
                    >
                    </el-switch>
                </el-form-item>
                <!-- 下拉选择使用状态 -->
                <!-- <el-form-item label="选择使用状态:" label-width="120px">
                    <el-select
                        v-model="submit_data.status"
                        :placeholder="submit_rules.status.placeholder"
                        style="width: 150px; margin-right: 20px"
                    >
                        <el-option label="启用" value="1"></el-option>
                        <el-option label="禁用" value="0"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="是否指定计费模式:" label-width="130px">
                    <el-switch v-model="submit_data.use_mode" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>
                <el-form-item label="是否指定商家:" label-width="130px">
                    <el-switch v-model="submit_data.business_mode" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>
                <!-- 选择订单模式 -->
                <div>
                    <el-form-item label="请选择指定计费模式:" label-width="160px" v-if="submit_data.use_mode === '1'">
                        <el-select
                                v-model="value_mode_code"
                                placeholder="请选择模式"
                                @visible-change="modeVisibleChange"
                                @change="modeChange"
                                clearable
                                style="position: relative"
                        >
                            <el-option
                                    v-for="item in options_mode_code"
                                    :key="item.value"
                                    :label="item.order_mode.name"
                                    :value="item.order_mode.order_mode_code"
                            >
                            </el-option>

                            <selectPages
                                    :search_data="mode_options_data"
                                    :result_data="selectPages_data"
                                    @selectPages_function="selectPages_function"
                            ></selectPages>

                        </el-select>
                    </el-form-item>
                </div>

            </el-form>
            <!-- 对话框底部按钮 -->
            <div style="display: flex; justify-content: center">
                <submitBtn
                        :data="submit_data"
                        :rules="submit_rules"
                        url="/activity/editActiveConf"
                        @onSubmitDig="onSubmitDig"
                        @toJSON="toJSON"
                        :JSON_Boolean="true"
                />

                <el-button @click="closeDialog">返回</el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>
    var _this;

    export default {
        props: {
            isShow: Boolean
        },
        components: {},
        watch: {
            isShow(newData, oldData) {
                _this.show = true;

                _this.$post('/activity/getActiveConf', _this.search_data)
                    .then((res) => {
                        if(res.data.length != 0){

                            _this.submit_data.type = res.data.type;
                            _this.submit_data.share_money = res.data.share_money;
                            _this.submit_data.driver_bear = res.data.driver_bear;
                            _this.submit_data.face_new = res.data.face_new;
                            _this.submit_data.use_mode = res.data.use_mode;
                            _this.submit_data.status = res.data.status;
                            _this.submit_data.order_mode_code = res.data.order_mode_code;
                            _this.value_mode_code = res.data.order_mode_name;
                            _this.submit_data.business_mode = res.data.business_mode;

                        }else{
                            console.log(_this.submit_data,'=========');
                        }
                    })
                    .catch((err) => {
                    });
            }
        },
        data() {
            return {
                show: false,
                // 下拉搜索模式
                value_mode_code: '',
                options_mode_code: [],
                mode_options_data: {
                    page: 1,
                    limit: 5
                },

                selectPages_data: [],
                // 表单数据
                submit_data: {
                    type: '1',
                    share_money: '',
                    driver_bear: '',
                    face_new: '',
                    use_mode: '',
                    order_mode_code: '',
                    status: '',
                    business_mode:'0'
                },
                search_data: {
                    // city_group_code: '',
                    type: '1'
                },

                submit_rules: {
                    share_money: {
                        placeholder: '请输入奖励金额',
                        rules: {
                            required: true,
                            message: '金额需为1-999999的数字',
                            regulation: 'egt',
                            rulesData: 0
                        }
                    },
                    driver_bear: {
                        placeholder: '请输入司机承担金额',
                        rules: {
                            required: true,
                            message: '金额需为1-999999的数字',
                            regulation: 'egt',
                            rulesData: 0
                        }
                    },
                    order_mode_code: {
                        placeholder: '指定计费模式',
                        rules: {
                            required: false,
                            message: '指定计费模式错误',
                            regulation: 'egt_str',
                            rulesData: 0
                        }
                    }
                }
            };
        },
        created() {
            _this = this;
        },
        methods: {
            selectPages_function(submit_data) {
                _this.mode_options_data = submit_data;

                _this.orderModeList();
            },
            orderModeList() {
                // 请求公司管理接口获取公司唯一编码
                _this
                    .$post('/order/orderModeLists', _this.mode_options_data)
                    .then((res) => {
                        _this.selectPages_data = res;
                        _this.options_mode_code = res.data;
                    })
                    .catch((err) => {
                    });
            },

            //搜索的下拉框弹出触发
            modeVisibleChange(val) {
                _this.orderModeList();
            },
            modeChange(val) {
              
                _this.submit_data.order_mode_code = val;
            },


            // 关闭方法
            closeDialog() {
                _this.submit_data = {
                    type: '1',
                    share_money: '',
                    driver_bear: '',
                    face_new: '',
                    use_mode: '',
                    order_mode_code: '',
                    status: '',
                    business_mode:'0'
                };
                _this.show = false;
                _this.value_mode_code = '';
            },
            toJSON() {
                console.log(_this.submit_data.use_mode,'_this.submit_data.use_mode==-=-=');
                // 如果计费模式开关打开
                if (_this.submit_data.use_mode === '1') {
                    // 计费模式必填项
                    _this.submit_rules.order_mode_code.rules.required = true;
                }else {
                    _this.submit_rules.order_mode_code.rules.required = false;
                }
                console.log(_this.submit_data);
            },
            // 提交
            onSubmitDig() {
                _this.$emit('onSubmit');

                _this.closeDialog();

            }
        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }
</style>
